<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="unnumbered-2">
<div class="heading heading-with-title heading-without-image" id="unnumbered-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Renegade Justice Thrillers, featuring Morgan Ames</h1>
</div>
<h2 class="subtitle">Meet Everyone’s Favorite Teenage Psychopath…</h2>
</div>
</div>
</div>
<div class="text" id="unnumbered-2-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center">Readers fell in love with Morgan in the Lucy Guardino thrillers and begged for more of everyone’s favorite teenaged psychopath…</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-large inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="Renegade Justice" src="images/morgan.jpg"/>
</div>
</div>
</div>
</div>
<p class="first first-in-chapter first-full-width"><span class="first-phrase">Morgan’s story</span> begins in the second book of the Lucy Guardino thriller series, with Lucy’s husband, Nick, playing a significant role as Morgan tries to shun her serial-killer father’s indoctrination and give up violence.</p>
<p class="subsq">To see how Morgan’s story fits in Lucy’s world, the stories in order are:</p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">SNAKE SKIN</a>, Lucy Guardino FBI Thrillers Book #1</p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">BLOOD STAINED</a>, introduces Morgan and Jenna</p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">KILL ZONE</a>, features Morgan and Jenna, introduces Andre</p>
<p class="subsq"><b>The Renegade Justice Thrillers</b> (taking place in the year between KILL ZONE and AFTER SHOCK):</p>
<p class="subsq"><a class="content-external-link" href="http://cjlyons.net/renegade-justice/" target="_blank">FIGHT DIRTY, Renegade Justice #1</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">RAW EDGES, Renegade Justice #2</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">ANGELS WEEP, Renegade Justice #3</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">LOOK AWAY, Renegade Justice #4</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">TRIP WIRE, Renegade Justice #5</a></p>
<p class="subsq"><b>The Lucy Guardino Thrillers </b>continue<b>, </b>chronicling Lucy’s departure from the FBI and her new adventures at Beacon Falls:</p>
<p class="subsq"><a class="content-external-link" href="http://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">AFTER SHOCK</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">HARD FALL</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">BAD BREAK</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">LAST LIGHT</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">DEVIL SMOKE</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">OPEN GRAVE</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">GONE DARK</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">BITTER TRUTH</a></p>
<p class="subsq"><a class="content-external-link" href="https://cjlyons.net/books/lucy-guardino-fbi-thrillers/" target="_blank">LESSER EVIL</a></p>
<hr class="implicit-break"/>
<p class="first first-in-section first-full-width"><span class="first-phrase">Want</span> to be the first to have a chance to read the new books? Sign up for my <a class="content-external-link" href="http://cjlyons.net/signup" target="_blank">Thrillers with Heart newsletter HERE</a></p>
<p class="subsq">Be sure to open the Thrillers with Heart emails; they’ll arrive every few weeks with info on contests, new books, and exclusive offers for my readers!</p>
<div class="inline-image inline-image-kind-freestanding inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide inline-image-without-caption inline-image-after-section-begin">
<div class="inline-image-container">
<a class="link-contains-image" href="http://cjlyons.net/signup" target="_blank">
<img alt="Thanks for reading! CJ" src="images/image-300thanks-448.jpg"/>
</a>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// renegadejusticethrillersfeaturingmorganames.vue?208f6bbf